<template>
  <div>
    <div class="title-section">
      <div class="title">
        <span>团队负责人</span>
      </div>
      <div class="title-line"></div>
      <div class="title-subtitle">Group Leader</div>
    </div>
    <div v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)">
      <div style="margin-top: 20px" class="between" v-if="leaderData.name">
        <div class="namePath">
          <el-image
            style="width: 150px; height: 200px"
            fit="cover"
            :src="leaderData.headImage"
          ></el-image>
          <div class="text">
            <div>
              <h1>{{ leaderData.name }}</h1>
              <h2>{{ leaderData.englishName }}</h2>
            </div>
            <p class="ql-editor" v-html="leaderData.officeAddress"></p>
          </div>
        </div>
        <div class="inner right">
          <div v-if="leaderData.tel">电话: {{ leaderData.tel }}</div>
          <div v-if="leaderData.email">邮箱: {{ leaderData.email }}</div>
        </div>
      </div>
      <div class="title" style="margin-top: 20px" v-if="leaderData.name">
        <span>个人简介</span>
        <div class="title-line"></div>
      </div>
      <div class="inner" v-if="leaderData.name">
        <div class="ql-editor" v-html="leaderData.description"></div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
import { listGroupMember } from '@/api/api'
export default {
  data () {
    return {
      leaderData: {},
      loading: true
    }
  },
  created () {
    this.getLeaderData()
  },
  methods: {
    getLeaderData () {
      this.loading = true
      listGroupMember().then((res) => {
        if (res.data) {
          let arr = []
          res.data.forEach((element) => {
            element.memberList.forEach((i) => {
              arr.push(i)
            })
          })
          this.leaderData = arr.filter((item) => {
            return item.name === '张坚'
          })[0] || {}
          if (!this.leaderData.name) {
            alert('请在后台管理系统添加"张坚"的信息')
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    NToList () {
    }
  }
}
</script>

<style scoped>
.title-section {
  position: relative;
  margin-bottom: 32px;
}

.title {
  font-size: 36px;
  line-height: 1.4;
  color: #2f4f4f;
  font-weight: 700;
  letter-spacing: 3px;
  animation: titleFloatIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.title-subtitle {
  position: absolute;
  right: 0;
  top: 10px;
  font-size: 14px;
  color: #888;
  letter-spacing: 8px;
  text-transform: uppercase;
  animation: subtitleFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;
  opacity: 0;
}

@keyframes subtitleFadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes titleFloatIn {
  from {
    opacity: 0;
    transform: translateY(-40px);
    letter-spacing: 10px;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    letter-spacing: 3px;
  }
}
.title-line {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2f4f4f, #5a8a8a);
  border-radius: 2px;
  animation: lineSlideIn 1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
  transform-origin: left;
  transform: scaleX(0);
}

@keyframes lineSlideIn {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
.inner {
  margin-top: 20px;
}
.namePath {
  display: flex;
  align-items: center;
  width: 800px;
}
.namePath .text {
  margin-left: 20px;
}
h1 {
  letter-spacing: 20px;
}
.between{
  display: flex;
  justify-content: space-between;
}
.right{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 280px;
  height: 200px;
  margin-top: 0;
  flex-shrink: 0;
  line-height: 30px;
}
.text{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 200px;
}
</style>
